import LottiePlayer from 'components/lottie-player';
import scrollAnimation from 'components/lottie-player/animations/scroll-down.json';
import {useTranslation} from "react-i18next";
import { Link } from 'react-router-dom';

import './Hero.css';

const Hero = ({circulationData}) => {
  const {t} = useTranslation();

  return (
    <div className="hero">
      <div className="container hero__container">
        <div className="hero__caption">
          <p className="hero__title">{t("HOME_HERO_TITLE")}</p>
          <p className="hero__description">{t("HOME_HERO_DESCRIPTION")}</p>
          <p className="hero__amount">
            <span>{circulationData?.jackpotAmount}</span>
            <span>₼</span>
          </p>
          <Link to="/bron" className="hero__link">
            {t("BRON_NOW")}
          </Link>
        </div>
        <div className="hero__scroll">
          <span className="hero__scroll-text">{t("SCROLL_DOWN")}</span>
          <LottiePlayer
            animation={scrollAnimation}
            width="56px"
            height="56px"
          />
        </div>
      </div>
      <div className="hero__gradient"></div>
    </div>
  );
};

export default Hero;
